'use client';

import { cn } from '@/lib/utils';
import * as Tooltip from '@radix-ui/react-tooltip';

interface Props {
  children: React.ReactNode;
  tooltipContent: React.ReactNode;
  containerClassName?: string;
}

export default function SimpleTooltip({
  children,
  tooltipContent,
  containerClassName,
}: Props) {
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="bottom"
            sideOffset={8}
            className={cn(
              'z-50 font-body rounded bg-white py-2 px-4 text-sm shadow-md animate-fade-in',
              containerClassName,
            )}
          >
            {tooltipContent}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
